module.exports = __webpack_public_path__ + "img/code.ba83bd18.png";